import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      {/* CTA Section */}
      <div className="relative overflow-hidden border-b border-orange-500/10"
        style={{ background: 'linear-gradient(135deg, rgba(249,115,22,0.07) 0%, rgba(0,0,0,0.0) 50%, rgba(217,119,6,0.05) 100%)' }}>
        {/* Decorative corner lines */}
        <div className="absolute top-0 left-0 w-24 h-24 border-t border-l border-orange-500/15"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 border-b border-r border-orange-500/15"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Transform Your Vision Into Reality
          </h3>
          <p className="text-xl text-gray-400 mb-8 max-w-3xl mx-auto">
            From automotive showcases to life's most precious moments, our professional cinematography team delivers exceptional quality. Let's create something extraordinary together.
          </p>
          <Link
            to="/shoot-with-us"
            className="group relative inline-flex items-center gap-3 px-10 py-5 text-white font-bold text-lg rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/30 overflow-hidden mx-auto"
            style={{ background: 'linear-gradient(135deg, #f97316 0%, #b45309 100%)' }}
            data-testid="shoot-with-us-btn"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full"
              style={{ transition: 'transform 0.7s ease' }}></div>
            <span>Shoot With Us Now</span>
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-amber-400 bg-clip-text text-transparent mb-4">
              TAF WORLDWIDE
            </h3>
            <p className="text-gray-400 mb-4">
              Professional cinematography and videography services for your most important moments.
            </p>
            <div className="flex gap-3">
              <a href="#" className="social-icon">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400">
                <Mail className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:admin@tafworldwide.com" className="hover:text-white transition-colors">
                  admin@tafworldwide.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Phone className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <a href="tel:+601133131844" className="hover:text-white transition-colors font-semibold"
                  data-testid="footer-phone">
                  +60 11-3313 1844
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <span>Malaysia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} TAF WORLDWIDE. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
